<template>
    <button
        v-tippy="t('editorToggleTextAlignCenter')"
        :class="[
            buttonState(true, editor.isActive({ textAlign: 'center' })),
            'flex-none rounded p-1 text-sm',
        ]"
        @click="editor.chain().focus().setTextAlign('center').run()"
    >
        <MdiFormatAlignCenter class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiFormatAlignCenter from 'materialdesignicons-vue3/icons/MdiFormatAlignCenter.js';

    defineExpose({
        name: 'TextAlignCenterButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
